$(document).ready(function () {
    $('.sort_ .selection_').click(function () {
        $('.sort_ .detail_').toggleClass('detail_show_');
    });
    $('.refine_ .selection_').click(function () {
        $('.refine_ .detail_').toggleClass('detail_show_');
    });
});

window.initMaps = function () {
    if (showMainEventMap) {
        $('input[name="main_event_map_latitude"]').val(0);
        $('input[name="main_event_map_longitude"]').val(0);
        updateMainEventMap();
    }

    if (showSubEventMap) {
        $('input[name="sub_event_map_latitude"]').val(0);
        $('input[name="sub_event_map_longitude"]').val(0);
        updateSubEventMap();
    }
};

window.updateMainEventMap = function () {
    var params = prepareDynamicParams($('input[name="main_event_hall_address"]').val(), $('input[name="main_event_hall_name"]').val(), $('input[name="main_event_map_zoom"]').val(), $('input[name="main_event_map_latitude"]').val(), $('input[name="main_event_map_longitude"]').val());
    prepareMainEventMap(params);
};

window.updateSubEventMap = function () {
    var params = prepareDynamicParams($('input[name="sub_event_hall_address"]').val(), $('input[name="sub_event_hall_name"]').val(), $('input[name="sub_event_map_zoom"]').val(), $('input[name="sub_event_map_latitude"]').val(), $('input[name="sub_event_map_longitude"]').val());
    prepareSubEventMap(params);
};

window.prepareDynamicParams = function (address, markerTitle, zoom, lat, lng) {
    var params = {};
    params['address'] = address;
    params['markerTitle'] = markerTitle;
    params['zoom'] = zoom;
    params['lat'] = lat;
    params['lng'] = lng;
    return params;
}

window.prepareMainEventMap = function (params) {
    prepareMap(params, "map_wedding", "main_event_map_zoom", "main_event_map_latitude", "main_event_map_longitude");
}

window.prepareSubEventMap = function (params) {
    prepareMap(params, "map_reception", "sub_event_map_zoom", "sub_event_map_latitude", "sub_event_map_longitude");
}

function prepareMap(params, mapId, zoomField, latField, lngField) {
    var mapGeocoder = new google.maps.Geocoder();
    mapGeocoder.geocode({ 'address': params['address'] }, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
            var latLng = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
            var mapArea = document.getElementById(mapId);
            var map = new google.maps.Map(mapArea, createMapOptions(params, latLng));
            var marker = createMarker(latLng, map, params['markerTitle']);

            addListenersToMap(map, zoomField, latField, lngField);

            $('input[name="' + zoomField + '"]').val(map.getZoom());
            $('input[name="' + latField + '"]').val(map.getCenter().lat());
            $('input[name="' + lngField + '"]').val(map.getCenter().lng());
        }
    });
}

$(function () {
    $('input.scroll_btn_').click(function () {
        var speed = 500;
        $("html, body").animate({ scrollTop: 450 }, speed, "swing");
        return false;
    });
});

function createMapOptions(params, latLng) {
    var zoom = defaultZoom;
    if ($.isNumeric(params['zoom'])) {
        zoom = parseInt(params['zoom']);
    }

    return {
        zoom: zoom,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        center: getMapCenter(params['lat'], params['lng'], latLng),
        scrollwheel: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP
    };
}

function getMapCenter(lat, lng, latLng) {
    if (lat != 0 && lng != 0) {
        return new google.maps.LatLng(lat, lng);
    } else {
        return new google.maps.LatLng(latLng.lat(), latLng.lng());
    }
}

function createMarker(latLng, map, markerTitle) {
    new google.maps.Marker({
        position: latLng,
        map: map,
        title: markerTitle
    });
}

function addListenersToMap(map, zoomField, latField, lngField) {
    map.addListener('zoom_changed', function () {
        $('input[name="' + zoomField + '"]').val(map.getZoom());
    });

    map.addListener('center_changed', function () {
        var ll = map.getCenter();
        $('input[name="' + latField + '"]').val(ll.lat());
        $('input[name="' + lngField + '"]').val(ll.lng());
    });
}

window.prepareMapEmbedded = function (apiKey, mapId, address, zoom, latitude, longitude, locale) {
    var positionOfIframe = document.getElementById(mapId);
    if (zoom && latitude) {
        positionOfIframe.innerHTML = '<iframe width="100%" height="100%" frameborder="0" style="border:0" src="https://www.google.com/maps/embed/v1/place?q=' + address + '&key=' + apiKey + '&center=' + latitude + ',' + longitude + '&zoom=' + zoom + '&language=' + locale + '" allowfullscreen=""></iframe>';
    } else {
        positionOfIframe.innerHTML = '<iframe width="100%" height="100%" frameborder="0" style="border:0" src="https://www.google.com/maps/embed/v1/place?q=' + address + '&key=' + apiKey + '&language="' + locale +'" allowfullscreen=""></iframe>';
    }
}

$(document).ready(function () {
    $('.index .content_box_').click(function () {
      $('.index .content_box_').toggleClass('shown');
    });
    $('.index .content_box2_').click(function () {
      $('.index .content_box2_').toggleClass('shown');
    });
});